import { ComponentProps, useMemo } from "react";
import { skeletonClasses, SkeletonVariants } from "./Skeleton.style";

type SkeletonProps = SkeletonVariants &
  ComponentProps<"div"> & {
    className?: string;
    size?: number;
    width?: number;
  };

const Skeleton = (props: SkeletonProps) => {
  const {
    variant = "rounded",
    className,
    size,
    width,
    children,
    isAnimate,
    ...rest
  } = props;

  const dimensions = useMemo(() => {
    if (variant === "circle") {
      return {
        height: `${size}px`,
        width: `${size}px`,
      };
    } else {
      return {
        height: `${size}px`,
        width: `${width}%`,
      };
    }
  }, [size, variant, width]);
  return (
    <div
      className={skeletonClasses({
        variant,
        class: className,
        hasChild: !!children,
        isAnimate,
      })}
      style={dimensions}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Skeleton;
